import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Logo } from '../Logo';
import { Box } from '../Box';

const StyledContainer = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'column',
});

const StyledLogoContainer = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(16)} 0`,
}));

const StyledSpacer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(30),
  paddingBottom: theme.spacing(2),
}));

const StyledContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

export type PageWithLogoProps = {
  children: ReactNode;
};

export const PageWithLogo = ({ children }: PageWithLogoProps) => {
  return (
    <StyledContainer>
      <StyledLogoContainer>
        <Logo />
      </StyledLogoContainer>
      <StyledContent>{children}</StyledContent>
      <StyledSpacer />
    </StyledContainer>
  );
};
